import { createFileRoute } from '@tanstack/react-router'
import { AcceptInvitePage } from '#pages/auth/AcceptInvitePage'

export const Route = createFileRoute('/invite')({
  validateSearch: (search: Record<string, unknown>) => ({
    token: typeof search.token === 'string' ? search.token : '',
  }),
  // Route reads search params and passes as props — avoids circular import from page → route
  component: function InviteRoute() {
    const { token } = Route.useSearch()
    return <AcceptInvitePage token={token} />
  },
})
